import { Col, Input, Label } from "reactstrap";
import { IconCheckbox } from "../../../../Constant";
import { CUSTOM_CHECKBOX_LIST } from "../../../../Data/FormControl/CheckboxAndRadio";
import { H6, LI, UL } from "../../../../AbstractElements";

export const IconCheckboxs = () => {
  return (
    <Col xl="4" sm="12" className="order-xl-0 order-sm-1">
      <div className="card-wrapper border rounded-3 h-100 checkbox-checked">
        <H6 className="sub-title">{IconCheckbox}</H6>
        <div className="form-check checkbox checkbox-primary ps-0 main-icon-checkbox">
          <UL className="checkbox-wrapper d-flex flex-row simple-list">
            <LI className="p-1 pt-2 pb-2">
              <Input className="checkbox-shadow" id="checkbox-icon" type="checkbox" />
              <Label htmlFor="checkbox-icon" check>
                <i className="fa fa-sliders"></i><span>Sliders</span>
              </Label>
            </LI>
            {CUSTOM_CHECKBOX_LIST.map(({ icon, id, text, defaultChecked }, index) => (
              <LI className="p-1 pt-2 pb-2" key={index}>
                <Input className="checkbox-shadow" id={`checkbox-icon-${id}`} type="checkbox" defaultChecked={defaultChecked} />
                <Label htmlFor={`checkbox-icon-${id}`} check>
                  <i className={`fa fa-${icon}`}></i>
                  <span>{text}</span>
                </Label>
              </LI>
            ))}
          </UL>
        </div>
      </div>
    </Col>
  );
};